import { ChangeDetectorRef, Component } from '@angular/core';
import { ImportsModule } from "../../shared/imports.module";
import { Sociedad, Division, Beneficiario, Usuario } from '../../shared/models';
import { CommonModule, CurrencyPipe, DatePipe, SlicePipe } from '@angular/common';
import { RolesService } from '../../shared/services/roles.service';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { saveAs } from 'file-saver';
import { finalize, lastValueFrom, Subject, takeUntil } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { BeneficiariosDetallesComponent } from './beneficiarios-detalles/beneficiarios-detalles.component';
import { BeneficiariosService } from '../../shared/services/beneficiarios.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { FormsModule } from '@angular/forms';
import { SubirArchivosBeneficiarioComponent } from '../../shared/components/subir-archivos-beneficiario/subir-archivos-beneficiario.component';
import { PerfilStore } from '../../shared/store/perfil.store';
import { Router } from '@angular/router';
import { CatalogosService } from '../../shared/services/catalogos.service';


@Component({
  selector: 'app-beneficiarios',
  standalone: true,
  imports: [ImportsModule, CommonModule, DatePipe, NzSpinModule, NzDatePickerModule, FormsModule],
  templateUrl: './beneficiarios.component.html',
  styleUrl: './beneficiarios.component.scss'
})
export class BeneficiariosComponent {
  constructor(
    private rolesService: RolesService,
    private drawerService: NzDrawerService,
    private message: NzMessageService,
    private beneficiariosService: BeneficiariosService,
    private modal: NzModalService,
    private cdr: ChangeDetectorRef,
    private sessionStore: PerfilStore,
    private router: Router,
    private catalogos: CatalogosService
  ) {}

  beneficiarios ?: Beneficiario[] = [];
  beneficiariosFiltrados ?: Beneficiario[] = [];
  searchText?: string = '';
  loading = false;
  isVisible : boolean = false;
  isConfirmLoading : boolean = false;
  fechaBaja: Date | null = null;
  fechaFinalizacion: Date | null = new Date();
  BeneficiarioSeleccionado ?: Beneficiario;
  user : Usuario | null = null;
  $onDestroy: Subject<void> = new Subject<void>();
  NoAcceso: boolean = false;

  disabledDate = (current: Date): boolean => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    yesterday.setHours(23, 59, 59, 999);
    return current && current.getTime() > yesterday.getTime();
  };

  ngOnInit() {
    this.getUser();
  }

  getUser(){
    this.sessionStore.getPerfil()
    .pipe(takeUntil(this.$onDestroy))
    .subscribe((user) => {
      this.user = user;
      if(!this.user?.esRRHH && !this.user?.esMedico && !this.user?.esAdmin){
        this.$onDestroy.next();
        this.$onDestroy.complete();
        this.sessionStore.clearPerfil();
        this.router.navigate(['/']);
      }
      else {
          this.cargarBeneficiarios();
          this.obtenerPeriodo();
      }
    });
  }

     async obtenerPeriodo() {
        try {
          let ResPeriodos = await lastValueFrom(this.catalogos.obtenerCatalogoCalendario());
          if (ResPeriodos?.details && Array.isArray(ResPeriodos.details)) {
            this.evaluarAccesoPorFecha(ResPeriodos.details);
          }
        } catch (error) {
          console.error('Error al obtener periodos:', error);
          this.NoAcceso = true;
        }
      }
  
    evaluarAccesoPorFecha(periodos: any[]) {
      const fechaActual = new Date();
      const mesActual = fechaActual.getMonth() + 1;
      const añoActual = fechaActual.getFullYear();
      if (mesActual === 1 ) {
        this.NoAcceso = fechaActual > new Date('01/24/' + añoActual);
      }
      else if (mesActual >= 2 && mesActual <= 12) {
        const fechaLimite = new Date(periodos.find(periodo => 
          periodo.mesContable?.toLowerCase() === 'diciembre'
        )?.limiteInfoColaborador || '12/10/' + añoActual);
        if (fechaLimite) {
          this.NoAcceso = fechaActual < fechaLimite;
        } else {
          this.NoAcceso = false;
        }
      } else {
        this.NoAcceso = false;
      }
    }

  ngOnDestroy() {
    this.$onDestroy.next();
    this.$onDestroy.complete();
  }

  cargarBeneficiarios() {
    this.loading = true;
    this.beneficiariosService.obtenerListadoBeneficiarios()
    .pipe(
      finalize(() => {
        this.loading = false;
        this.cdr.detectChanges();
      }
    )
    ).subscribe(
      {
        next: (data) => {
          this.beneficiarios = data?.details as Beneficiario[];
          this.beneficiariosFiltrados = [...(this.beneficiarios ?? [])];
        },
        error: (error) => {
          console.error('Error al cargar beneficiarios:', error);
        }
      }
    );
  }

  onSearchChange( $event:any ) {
    this.searchText = $event.trim().toLowerCase();
    if (this.searchText?.length == 0) {
      this.beneficiariosFiltrados = [...this.beneficiarios!];
      return;
    }
    this.beneficiariosFiltrados = this.beneficiarios?.filter(beneficiario =>
      (beneficiario?.colaboradorNombre && beneficiario.colaboradorNombre.toLowerCase().includes(this.searchText!)) ||
      (beneficiario?.colaboradorApellidos && beneficiario.colaboradorApellidos.toLowerCase().includes(this.searchText!)) ||
      (beneficiario?.beneficiarioNombre && beneficiario.beneficiarioNombre.toLowerCase().includes(this.searchText!)) ||
      (beneficiario?.tipoGestacion && beneficiario.tipoGestacion.toLowerCase().includes(this.searchText!))
    );
  }

  verDetalles(beneficiario: Beneficiario) {
    const drawer = this.drawerService.create(
      {
        nzContent: BeneficiariosDetallesComponent,
        nzData: { beneficiario },
        nzWidth: 612
      }
    );
    
    drawer.afterClose.subscribe( ( data ) => {
        this.cargarBeneficiarios();
    });
  }

  AddBeneficiario(){
    const drawer = this.drawerService.create(
      {
        nzContent: SubirArchivosBeneficiarioComponent,
        nzData: null,
        nzWidth: 600
      }
    );
    drawer.afterClose.subscribe( ( data ) => {
        this.cargarBeneficiarios();
    });
  }


  eliminarBeneficiario(beneficiario: Beneficiario) {    
    this.BeneficiarioSeleccionado = beneficiario;
    this.isVisible = true;
  }

  Cancel() {
    this.isVisible = false;
    this.BeneficiarioSeleccionado = undefined;
    this.fechaFinalizacion = null;
  }

  confirmarBajaBeneficiario() {
      if (!this.fechaFinalizacion) {
        this.message.warning('Debe seleccionar una fecha de finalización');
        return;
      }

      const fechaFormateada = this.fechaFinalizacion.toISOString().split('T')[0];
      
      const objetoActualizacion = {
        Id: this.BeneficiarioSeleccionado!.id,
        EsInterrumpida: true,
        FechaFin: fechaFormateada
      };
      this.loading = true;
      this.isConfirmLoading = true;
      
      this.beneficiariosService.actualizarSolicitud(objetoActualizacion)
        .pipe(
          finalize(() => {
            this.loading = false;
            this.isConfirmLoading = false;
            this.cdr.detectChanges();
          })
        )
        .subscribe({
          next: (response) => {
            this.message.success(`Beneficiario ${this.BeneficiarioSeleccionado!.beneficiarioNombre} dado de baja correctamente`);
            this.Cancel();
            this.cargarBeneficiarios();
          },
          error: (error) => {
            console.error('Error al dar de baja el beneficiario:', error);
            this.message.error('Error al dar de baja el beneficiario. Intente nuevamente.');
          }
        });
  }

  getColor( estatus: string){
    let res = "default";
    switch (estatus) {
      case 'Gestación en curso':
        res = 'green';
        break;
      case 'Gestación interrumpida':
        res = 'red';
        break;
      case 'Gestación finalizada':
        res = 'blue';
        break;
      case 'Solicitud en espera de aprobacion':
        res = 'yellow';
        break;
      default:
        res = 'default';
      break;


    }
    return res;
  }

}
